/* eslint-disable */
export function API() {
  return process.env.REACT_APP_BASE_URL;
}

export default {
  authToken: "auth/token",
  login: "Login/LoginUser",
  ThirdPartyLogin: "Login/ThirdPartyLogin",
  GenerateUserToken: "Auth/GenerateUserToken",
  register: "Register",
  apiRegisterProposal: "proposal/registerProposal",
  eSewaPaymentCheckout: "Payment/EsewaCheckout",
  eSewaVerifyPayment: "Payment/EsewaPaymentVerification",
  apiNpxPayment: "proposal/GetNPXOpenPGGateway",
  apiKhaltiPayment: "proposal/ProposalKhaltiCheckout",

  apiGetDistrictLists: "Utility/GetDistrictLists",
  apiGeneratePolicy: "proposal/GeneratePolicy",
  apiPolicyPaper: "proposal/PolicyPaper",
  apiGetPDFRiderPaper: "Proposal/RiderPaper?id=",
  apiGetPDFPolicyNo: "Proposal/PolicyPaper?id=",
  apiGenerateReceipt: "proposal/GenerateReceipt",
  apiDashboardAllPolicies: "proposal/Dashboard",
  apiApproveProposal: "proposal/ApproveProposal",
  apiUnApproveProposal: "proposal/UnApproveProposal",
  apiForwardProposal: "proposal/ForwardProposal",
  apiGetUserList: "Register/GetUserList",
  apiViewDocument: "proposal/ViewDocument",
  apiGetProposal: "proposal/getProposal",
  apiManageProposal: "Proposal/ManageProposal",
  apiDeleteProposal: "proposal/deleteProposal",
  apiBusinessCount: "proposal/BusinessCount",
  apiDeleteHistory: "sunLifeOnline/GetDeleteSunGridList",
  apiPremiumCalculator: "/Utility/CalculatePremium",
  apiCalculatorValidate: "Utility/GetCalculatorValidation",
  apiCalculateAge: "Utility/CalculateAge",

  apiForgotPassword: "Register/ForgotPassword",
  apiVerifyForgotPasswordOTP: "Register/VerifyForgotPasswordOTP",
  apiChangePassword: "Register/ChangePassword",
  apiRecoverPassword: "Register/RecoverPassword",
  apiTermInsuranceRequiredDetailsList: "Proposal/GetProposalRequiredDetails",
  apiManageSunLifeTermInsurance: "sunLifeOnline/manageSunLifeTermInsurance",
  apiGetSunGridList: "Proposal/Dashboard",
  apiSunLifeTermPolicyIssued: "sunLifeOnline/SunLifeTermPolicyIssued",
  apiSunLifeTermInsuranceDetails:
    "sunLifeOnline/GetSunLifeTermInsuranceDetails",
  apigetProposalForEdit: "OnlineServices/getProposal",
  apiGetSunLifeTermRate: "sunLifeOnline/GetSunLifeTermRate",
  apiGetRequiredDetailsForDOFE: "FEInsurancev2/GetRequiredDetailsForDOFE",
  apiGetCustomerDetailsByPassportNo:
    "FEInsurancev2/GetCustomerDetailsByPassportNo",
  apiSaveFECustomerDetails: "FEInsurancev2/SaveFECustomerDetails",
  apiProceedFEPolicyGeneration: "FEInsurancev2/ProceedFEPolicyGeneration",
  apiGetDetailsByRegisterNo: "FEInsurancev2/GetDetailsByRegisterNo",
  apiDOFEGetGridList: "FEInsurancev2/GetGridList",
  apiChangeExpirePassword: "Register/ChangePassword",
  apiDeletePolicy: "Proposal/deleteProposal",

  apiGetProvinceLists: "Utility/GetProvinceLists",
  apiGetDistrictLists: "Utility/GetDistrictLists",
  apiGetMnuLists: "Utility/GetMnuLists",
  apiGetWardNoLists: "Utility/GetWardNoLists",
  apiGetUserTypeLists: "Utility/GetUserTypeLists",
  apiGenerateNepalPayQR: "SunLifeOnline/GenerateNepalPayQR",
  apiNepalPayVerificationPayment: "SunLifeOnline/NepalPayVerificationPayment",
  apiGenerateReport: "Proposal/ExportDashboardDetails",
  apiImePayment: "Proposal/Payment",

  apiGetPreviousPolicyStatusWithDetails:
    "Proposal/GetPreviousPolicyStatusWithDetails",
  apiGetLapsedPolicyListByUserId: "LapsedPolicy/GetLapsedPolicyListByUserId",
  apiGetLapsedPolicyDetailById: "LapsedPolicy/GetLapsedPolicyDetails",
  apiGetRevivedPolicyList: "LapsedPolicy/GetRegisteredLapsedGridList",
  apiGetRevivedPolicyById: "LapsedPolicy/GetRegisteredLapsedPolicyById",
};
